<div class="wrapper">
    <div class="col-4 hidden-mobile subproduct-header__image">
        <ng-content select=".subproduct-header-image"></ng-content>
    </div>
    <div class="col-5 subproduct-header__content">
        <ng-content select=".subproduct-header-content"></ng-content>
    </div>
    <div class="col-3 subproduct-header__sticker">
        <ng-content select=".subproduct-header-sticker"></ng-content>
    </div>
</div>
